/* Version: 3.5.155 */
'use client';
import { useContext } from 'react';
import NavigationContext from '../navigation/NavigationContext.js';

function useNavigation() {
  var _ref = useContext(NavigationContext) || {},
    _ref$isSignedIn = _ref.isSignedIn,
    isSignedIn = _ref$isSignedIn === undefined ? false : _ref$isSignedIn,
    mainNavWrapperRef = _ref.mainNavWrapperRef,
    subNavWrapperRef = _ref.subNavWrapperRef;
  return {
    isSignedIn: isSignedIn,
    mainNavWrapperRef: mainNavWrapperRef,
    subNavWrapperRef: subNavWrapperRef
  };
}

export { useNavigation as default };
